import clsx from 'clsx';
import React, { type PropsWithChildren } from 'react';

import styles from './UploadersList.css';

interface UploadersListProps {
    className?: string;
}

export function UploadersList({ children, className }: PropsWithChildren<UploadersListProps>) {
    return <div className={clsx(styles.root, className)}>{children}</div>;
}
